import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import FiltersStyles from '@stories/Components/Filters/Filters.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import APLFiltersStyles from '../APLFilters/APLFilters.styles';
import HeadingStyles from '../Global/Typography/Heading.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('fgColor', brand.black)};

  .theme-apl & {
    ${setCssVar('fgColor', brand.black)};
  }

  .theme-hh & {
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-rss & {
    ${setCssVar('fgColor', brand.white)};
  }

  ${FiltersStyles.Container}, ${APLFiltersStyles.Container} {
    margin: 0 0 var(--sectionMargin);
  }
`;
const Message = styled.p `
  ${ParagraphStyles.RegularStyles}
  margin-top: var(--sectionMargin);
`;
const Loading = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 100;
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 84px;
`;
const ListTitle = styled.h2 `
  ${HeadingStyles.H2Styles};
  color: ${cssVar('fgColor')};
  margin: 50px 0 30px;
`;
export default {
    Container,
    CtaWrapper,
    ListTitle,
    Loading,
    Message,
};
